export class InstancesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async getInstance(instanceId) {
        const response = await this.apiService.get(`instance/${instanceId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la instancia de formualrio.');
        }
        const content = await response.json();
        return this.createFormInstance(content);
    }
    async isInstance(formId) {
        const response = await this.apiService.get(`instance/initialized/${formId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la instancia de formualrio.');
        }
        const content = await response.json();
        return content.hasInstance;
    }
    async getInstances(query) {
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`instance/query?${params}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las instancias de formulario.');
        }
        const content = await response.json();
        return {
            results: content.results.map(data => this.createFormInstance(data)),
            numResults: content.numResults
        };
    }
    createFormInstance(data) {
        const { id, formId, isFinished, isDownloaded } = data;
        return {
            id,
            formId,
            isFinished,
            isDownloaded,
            dateCreated: new Date(data.dateCreated),
            dateCompleted: data.dateCompleted ? new Date(data.dateCompleted) : null,
            members: data.members.map(({ userId, signDate, isSigned, isOwner, signId, buddyId }) => {
                return {
                    userId,
                    isSigned,
                    isOwner,
                    signId,
                    signDate: signDate ? new Date(signDate) : null,
                    buddyId: buddyId ? buddyId : null,
                };
            }),
        };
    }
}
